import toastr from '../toastr/toastr.min.js';
import store from "../../store";

class AdvertiseService {
    constructor() {
    }

    newFeature(message, commitToMasterOn) {
        if (!store.getters["session/isInternalUser"]) return;

        if (!commitToMasterOn) throw "Specify date";
        commitToMasterOn = moment(commitToMasterOn, "MM/DD/YYYY");
        if (!commitToMasterOn.isValid()) throw "Specify valid date";

        const daysToAdvertise = 21;
        if (commitToMasterOn.add(daysToAdvertise, 'days').isBefore()) return;
        
        var messageId = message.replace(/,/gi, " ").substr(0, 100);
        
        var stored = localStorage.getItem("advertised");
        var previouslyAdvertised = stored ? stored.split(",") : [];
        
        if (previouslyAdvertised.includes(messageId)) return;

        toastr.success(message, "New Feature", 
            { 
                timeout: 10000, 
                positionClass: "toast-top-right", 
                preventDuplicates: true, 
                clickClose: true
            });

        previouslyAdvertised.push(messageId);
        localStorage.setItem("advertised", previouslyAdvertised.join(","));
    }
}

const advertise = new AdvertiseService();

export default advertise;




// WEBPACK FOOTER //
// ./src/framework/utils/advertise.js